module.exports = __webpack_public_path__ + "assets/img/14_896.e12ae482.jpg";